import * as yup from 'yup';

export const addSurgerySchema = yup.object({
    surgery_id: yup.number().label('number').positive('Debe seleccionar una cirugía').required('Este campo es requerido'),
    description: yup.string().label('description'),
});

export type addSurgerySchemaType = yup.InferType<typeof addSurgerySchema>
